<template>
  <div></div>
</template>

<script>
export default {
  name: "emailink",
  metaInfo() {
    return {
      title: this.$t("global.邮箱认证") + " | MANA"
    };
  },
  data() {
    return {
      email: "",
      code: "",
      type: ""
    };
  },
  created() {
    this.email = this.$query.email;
    this.code = this.$query.code;
    this.type = this.$query.type;
    this.emailLingF();
  },
  methods: {
    emailLingF() {
      this.$http
        .get("/api/passport/validEmail", {
          params: {
            email: this.email,
            code: this.code,
            type: this.type
          }
        })
        .then(response => {
          if (response.code === "OK") {
            if (this.type === "1") {
              let token = response.data;
              localStorage.setItem("auth_token", token);
              this.$message({
                message: response.message,
                type: "success"
              });
              setTimeout(() => {
                this.$router.push("/");
              }, 1000);
            }
            if (this.type === "2") {
              this.$router.push(`/resetPassword?code=${this.code}`);
            }
            if (this.type === "3") {
              this.$router.push("/login");
            }
          } else {
            this.$message({
              message: this.$t('global.链接已经失效'),
              type: "warning"
            });
          }
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/passport/emailink.vue